import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import DOMPurify from 'dompurify';
import { makeStyles } from 'tss-react/mui';
import { OfferResponse } from '../../sic-lib/api/offers/types/offerResponse';

interface Props {
    offer: OfferResponse;
}

export function OfferDetails({ offer }: Props) {
    const { classes } = useStyles();

    return (
        <Grid item container xs={12} md={6} flexDirection="column" spacing={4} p={4}>
            <Grid item>
                <Typography component="p" variant="h4" align="center">
                    {offer?.name}
                </Typography>
            </Grid>
            <Grid container item direction="column" justifyContent="center">
                <Grid container item direction="row" justifyContent="center">
                    <Typography component="p" variant="h2">
                        {`${offer?.items[0].amount}`}
                    </Typography>
                    <Typography component="p" variant="h6" alignSelf="flex-end">
                        /mo
                    </Typography>
                </Grid>
                <Grid container item justifyContent="center">
                    <Typography component="p" variant="overline">
                        {offer?.items[0].currency}
                    </Typography>
                </Grid>
                {!!offer?.trialDays && offer.trialDays > 0 && (
                    <Grid container item justifyContent="center">
                        <Typography
                            component="p"
                            variant="button"
                            paddingX={2}
                            className={classes.txtTrial}
                        >
                            {`${offer?.trialDays} days trial`}
                        </Typography>
                    </Grid>
                )}
            </Grid>
            <Grid item>
                <Typography component="p" variant="body2">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(offer?.description),
                        }}
                    />
                </Typography>
            </Grid>
            {/*
            <Grid item>
                <Typography component="p" variant="caption" alignSelf="flex-end">
                    What's Included
                </Typography>
                 <TableContainer>
                        <Table aria-label="product-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Product</TableCell>
                                    <TableCell align="right">Currency</TableCell>
                                    <TableCell align="left">Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {offer?.items.map(item => (
                                    <TableRow key={item.name}>
                                        <TableCell component="th" scope="row">
                                            {item.name}
                                        </TableCell>
                                        <TableCell align="right">{item.currency}</TableCell>
                                        <TableCell align="left">{item.amount}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer> 
            </Grid>
            */}
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    txtTrial: {
        // horizon: theme.spacing(2),
        borderRadius: theme.spacing(2),
        backgroundColor: theme.palette.backgroundMainLayout.main,
    },
}));
